import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentReaderService {
  private parsedDocData = new Subject();
  currentData = null;

  parsedDocData$ = this.parsedDocData.asObservable();
  private parsedDocDataDetail = new Subject();
  currentDataDetail = null;

  parsedDocDataDetail$ = this.parsedDocDataDetail.asObservable();

  constructor() {}

  docData(data) {
    this.currentData = data;
    this.parsedDocData.next(data);
  }

  docDataDetail(data) {
    this.currentDataDetail = data;
    this.parsedDocDataDetail.next(data);
  }
}
